export default {
  inject: {
    $page: {
      default: {}
    }
  },
  methods: {
    updateFilter(value) {
      this.$emit('change', value)
    }
  }
}
